/**
 * Order-number rule guard for the legacy checkout buttons (owner 2026-10-06; theme settings "Ordrenummer-regel",
 * KIT.orderRule in assets/myselfie-checkout.js). Loaded from snippets/myselfie-cart-rules.liquid (DK, every page).
 *
 * The DK cart page (assets/mys-cart.js) and the booking module check the rule themselves. This file covers the buttons
 * that submit the Shopify cart form straight to the checkout:
 *   - the legacy cart (sections/main-cart.liquid, /cart?view=legacy): "[name=checkout]" in .cartContainer. It has its own
 *     (stricter) gate; this adds the gallery-extension rule. The number typed in its order-number field counts.
 *   - the Vela ajax cart (snippets/vela-ajaxcart.liquid, only with ajax_cart_method modal / drawer; off today).
 * A blocked cart: message (legacy cart) and the cart page (field + message). An allowed cart: the click is
 * repeated untouched, so every other handler (terms box, api-dates.js gate) still runs. Vanilla ES5.
 */
(function () {
  'use strict';
  var M = (window.myselfie = window.myselfie || {});
  if (M.orderGuardActive || !M.orderRule) return;
  M.orderGuardActive = true;
  var SELECTOR = 'form.ajaxcart [name="checkout"], .cartContainer form [name="checkout"]';
  var pass = false;
  var busy = false;

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  document.addEventListener('click', function (e) {
    if (pass) return;
    var btn = e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
    var KIT = M.checkoutKit;
    if (!btn || !KIT || !KIT.orderRule) return;
    var legacy = !!btn.closest('.cartContainer');
    e.preventDefault();
    e.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        busy = false;
        var rule = KIT.orderRule(cart);
        var typed = btn.form && btn.form.querySelector('[name="attributes[orderNo]"]');
        var no = typed ? typed.value : (cart.attributes && cart.attributes.orderNo) || '';
        if (!rule.required || KIT.validOrderNo(no)) {
          pass = true;
          try { btn.click(); } finally { pass = false; }
          return;
        }
        var text = KIT.orderRuleText(rule);
        if (legacy) window.alert(text ? text.message : 'Der kræves et ordrenummer.');
        // the legacy cart has no order-number field unless the theme shows one: the cart page always has it
        if (!legacy || !typed) window.location.href = root() + 'cart';
      }, function () {
        busy = false;
        window.location.href = root() + 'cart'; // cannot check: the cart page does
      });
  }, true);
})();
